import { clsx, type ClassValue } from "clsx"
import { Timestamp } from "firebase/firestore";
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Recursively sanitizes Firestore data by converting Timestamps to ISO strings.
 * This is crucial for passing data from Server Components to Client Components.
 * @param data The data to sanitize (object, array, or any other type).
 * @returns The sanitized data.
 */
export function sanitizeFirestoreData(data: any): any {
  if (!data) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map(item => sanitizeFirestoreData(item));
  }
  
  if (typeof data === 'object' && data !== null && typeof data.toDate === 'function') {
    return data.toDate().toISOString();
  }

  if (typeof data === 'object' && data !== null) {
    const sanitizedObject: { [key: string]: any } = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        sanitizedObject[key] = sanitizeFirestoreData(data[key]);
      }
    }
    return sanitizedObject;
  }
  return data;
}


export function generateRandomPassword() {
  const length = 8;
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
}

